import React, { useState } from 'react';
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';
import { Button } from '../../../../../../../components';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const InfoSection = ({
  isView,
  user,
  form,
  shops,
  inactiveShops,
  shoppingCenters,
  filtersData,
}) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState('');
  const onChangeTypeSelect = (value) => {
    setSelectedType(value);
  };

  const onAdd = () => {
    const fields = form.getFieldValue('fields') || [];
    form.setFieldsValue({
      fields: [
        ...fields,
        {
          type: selectedType,
          title: '',
          value1: '',
          value2: '',
          value3: '',
          value4: '',
          value5: '',
          value6: '',
        },
      ],
    });
  };

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item
          rules={[{ required: true, message: 'Prego entra Outlet Village' }]}
          label={t('Outlet Village')}
          name='shopping_center_id'
        >
          <Select disabled={isView} placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters.map((shoppingCenter) => (
              <Select.Option key={shoppingCenter.id} value={shoppingCenter.id}>
                {shoppingCenter.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item
          rules={[{ required: true, message: 'Prego entra Insegna' }]}
          label={t('Insegna')}
          name='company_id'
        >
          <Select
            disabled={isView}
            {...Helpers.addSearchProps()}
            placeholder={t('Selezioni opzione')}
          >
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item label={t('Settore')} name='vacancy_application_type_id'>
          <Select disabled={isView} placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {filtersData.vacancy_application_types.map((shoppingCenter) => (
              <Select.Option
                key={shoppingCenter.value}
                value={shoppingCenter.value}
              >
                {shoppingCenter.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Data inserimento annuncio')}
          name='user_created_at'
        >
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Data pubblicazione')} name='published_at'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Data scadenza')} name='expired_at'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item label={t('Descrizione')} name='description'>
          <Input.TextArea
            disabled={isView}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
      {user.master_admin && (
        <Col offset={6} span={18}>
          <Form.Item
            disabled={isView}
            valuePropName={'checked'}
            name='hide_brand'
          >
            <Checkbox disabled={isView}>Nascondi insegna?</Checkbox>
          </Form.Item>
        </Col>
      )}
      <Col offset={6} span={18}>
        <Typography.Title level={3}>
          {t('INFORMAZIONI AGGIUNTIVE')}
        </Typography.Title>
      </Col>
      <Col offset={6} span={9}>
        <Space direction={'horizontal'}>
          <Select
            onSelect={onChangeTypeSelect}
            placeholder={t('Selezioni opzione')}
            disabled={isView}
          >
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value={1}>{t('Risposta aperta')}</Select.Option>
            <Select.Option value={3}>{t('Risposta chiusa')}</Select.Option>
          </Select>
          <Button onClick={onAdd} disabled={!selectedType}>
            {t('Nuovo')}
          </Button>
        </Space>
      </Col>
      <Col offset={6} span={18}>
        <br />
        <Form.List name='fields'>
          {(fields, { add, remove, ...rest }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => {
                  const fields = form.getFieldValue('fields') || [];
                  let type = fields[name] && fields[name].type;
                  if (type === 1) {
                    return (
                      <Space
                        key={key}
                        style={{ display: 'flex', marginBottom: 8 }}
                        align='baseline'
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'title']}
                          // rules={[
                          //   { required: true, message: 'Missing first name' },
                          // ]}
                        >
                          <Input.TextArea
                            disabled={isView}
                            rows={5}
                            style={{
                              width: 400,
                            }}
                            placeholder='Titolo del campo'
                          />
                        </Form.Item>
                        {!isView && (
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        )}
                      </Space>
                    );
                  } else if (type === 3) {
                    return (
                      <>
                        <Space
                          key={key}
                          style={{ display: 'flex', marginBottom: 8 }}
                          align='baseline'
                        >
                          <Form.Item {...restField} name={[name, 'title']}>
                            <Input.TextArea
                              disabled={isView}
                              rows={5}
                              style={{
                                width: 400,
                              }}
                              placeholder='Titolo del select list'
                            />
                          </Form.Item>
                          {!isView && (
                            <MinusCircleOutlined onClick={() => remove(name)} />
                          )}
                        </Space>
                        <Row gutter={8}>
                          <Col span={4}>
                            <Form.Item {...restField} name={[name, 'value1']}>
                              <Input
                                disabled={isView}
                                placeholder='Opzione risposta 1'
                              />
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                            <Form.Item {...restField} name={[name, 'value2']}>
                              <Input
                                disabled={isView}
                                placeholder='Opzione risposta 2'
                              />
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                            <Form.Item {...restField} name={[name, 'value3']}>
                              <Input
                                disabled={isView}
                                placeholder='Opzione risposta 3'
                              />
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                            <Form.Item {...restField} name={[name, 'value4']}>
                              <Input
                                disabled={isView}
                                placeholder='Opzione risposta 4'
                              />
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                            <Form.Item {...restField} name={[name, 'value5']}>
                              <Input
                                disabled={isView}
                                placeholder='Opzione risposta 5'
                              />
                            </Form.Item>
                          </Col>
                          <Col span={4}>
                            <Form.Item {...restField} name={[name, 'value6']}>
                              <Input
                                disabled={isView}
                                placeholder='Opzione risposta 6'
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    );
                  }
                })}
              </>
            );
          }}
        </Form.List>
      </Col>
    </Row>
  );
};

export default InfoSection;
